import React from "react";
import CompleteNewPassword from "../components/Auth/CompleteNewPassword";

const CompletarNuevaContrasena = props => {
  if (
    props.authState !== "signedIn" ||
    !props.authData ||
    props.authData.challengeName !== "NEW_PASSWORD_REQUIRED"
  ) {
    return null;
  }

  return <CompleteNewPassword {...props} />;
};

export default CompletarNuevaContrasena;
